(function($) {

  /* ==== LAZY-LOAD BACKGROUND-IMAGE ==== */

  /**
   *
   * HOW TO USE:
   *
   * 1. Add data-src-[breakpoint] to element.
   *    Ex: <div data-src-xs="/path/to/image.jpg">
   *
   *    It is possible to add multiple data-src-[breakpoint] to the same
   *    element. If multiple are present, the correct src breakpoint will be used
   *    according to the current window size.
   *    Ex: <div data-src-xs="/path/to/image-xs.jpg" data-src-lg="/path/to/image-lg.jpg">
   *
   * 2. Add .lazy-load-bg-img class to element.
   *
   */

  /**
   * Define breakpoints
   */
  var breakpoints = [];
  breakpoints['xxxl'] = 1600,
  breakpoints['xxl'] = 1400,
  breakpoints['xl'] = 1200,
  breakpoints['lg'] = 992,
  breakpoints['md'] = 768,
  breakpoints['sm'] = 576,
  breakpoints['xs'] = 0;

  /**
   * Get Current Window Size
   */
  function getWindowSize() {

    for (var key in breakpoints) {
      if (window.innerWidth >= breakpoints[key]) return key;
    }

    return 'xs';
  }

  /**
   * Background Image Handler
   */
  function handleBackgroundImage(image) {

    // Get current image size
    var currentWindowSize = image.attr('data-current-breakpoint');

    // Get required image size
    var windowSize = getWindowSize();

    if (currentWindowSize !== windowSize) {

      var validBreakpoint = false;
      var breakpointsKeys = Object.keys(breakpoints);

      for (var i = 0; i < breakpointsKeys.length; i++) {

        if (windowSize === breakpointsKeys[i]) {
          validBreakpoint = true;
        }

        if (validBreakpoint) {

          // Get image src
          var src = image.attr('data-src-' + breakpointsKeys[i]);

          if (typeof src !== 'undefined') {

            // Change image size
            image.css('background-image', 'url("' + src + '")');

            // Change current window size attribut data
            image.attr('data-current-breakpoint', windowSize);

            // Exit loop
            break;

          }

        }

      }

    }

  }

  /**
   * Page Init
   */
  $(document).ready(function() {

    /**
     * Handle Background Image
     */
    $('.lazy-load-bg-img').each(function() {
      handleBackgroundImage($(this));
    });

    /**
     * Save Current Window Breakpoint On <Body>
     */
    $('body').attr('data-current-breakpoint', getWindowSize());


  });

  /**
   * Page Resize
   */
  $(window).resize(function() {

    /**
     * Handle Window Breakpoint Change
     */
    var currentWindowSize = getWindowSize();
    if($('body').attr('data-current-breakpoint') !== currentWindowSize) {

      /**
       * Handle Background Image
       */
      $('.lazy-load-bg-img').each(function() {
        handleBackgroundImage($(this));
      });

      /**
       * Save Current Window Breakpoint On <Body>
       */
      $('body').attr('data-current-breakpoint', currentWindowSize);

    }

  });

})(jQuery);
